<template>
  <div>
    <vcl-facebook secondary="#ff9f43" v-if="loading"></vcl-facebook>
    <div v-if="!loading" class="vx-card">
      <div class="p-2">
        <vs-table
          id="tblSubscriptionUnits"
          max-items="50"
          search
          pagination
          :data="list"
          maxHeight="27vw"
          noDataText="Kayıt bulunamadı"
        >
          <template slot="header">
            <div class="flex items-end items-center px-3">
              <vs-button
                id="addNew"
                @click.stop="displayAddNewPopup = true"
                style="width: 175px"
                >Yeni Abonelik Ürünü</vs-button
              >
            </div>
          </template>

          <template slot="thead">
            <vs-th class="hidden">#</vs-th>
            <vs-th style="width: 600px">Abonelik Ürünü</vs-th>
            <vs-th>Bağlı Ürün</vs-th>
            <vs-th>İşlemler</vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr
              :state="tr.product[0].id == -1 ? 'warning' : 'success'"
              :key="i"
              v-for="(tr, i) in data"
            >
              <vs-td :data="tr.id" class="hidden">{{ tr.id }}</vs-td>
              <vs-td :data="tr.value" :title="tr.value" class="p-2">{{
                tr.value.substr(0, 50)
              }}</vs-td>
              <vs-td
                :data="tr.product[0].value"
                :title="tr.product.value"
                class="p-2"
                >{{ tr.product[0].value }}</vs-td
              >
              <vs-td class="p-2">
                <a
                  class="cursor-pointer"
                  title="Düzenle"
                  @click="displayEdit(tr)"
                >
                  <feather-icon class="w-6" icon="Edit2Icon"></feather-icon>
                </a>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <vs-prompt
        name="addNewPopup"
        vs-title="Yeni abonelik ürünü oluştur"
        vs-accept-text="Oluştur"
        vs-cancel-text="Vazgeç"
        vs-button-cancel="border"
        @vs-cancel="cancel"
        @vs-accept="accept"
        @vs-close="cancel"
        :vs-is-valid="isAllValid"
        :vs-active.sync="displayAddNewPopup"
      >
        <div class="vx-row mb-2">
          <div class="vx-col w-full flex small-icon">
            <vs-input
              icon-pack="feather"
              class="w-full"
              placeholder="Abonelik ürünü adı giriniz"
              v-model="tModel.name"
            />
          </div>
        </div>
        <div class="vx-row mb-2">
          <div class="vx-col w-full flex small-icon">
            <vs-input
              icon-pack="feather"
              class="w-full"
              placeholder="Bağlı bulunduğu ürünü seçiniz"
              v-model="tModel.product"
              list="lstProducts"
              autocomplete="off"
            />
            <datalist
              id="lstProducts"
              :key="i"
              v-for="(tr, i) in filteredProducts"
            >
              <option>{{ tr.value }}</option>
            </datalist>
          </div>
        </div>
        <div class="vx-row mb-2">
          <div class="vx-col w-1/2 flex small-icon">
            <vs-input
              type="number"
              class="w-full"
              placeholder="Yıllık üyelik ücretini giriniz"
              v-model="tModel.price"
            />
          </div>
          <div class="vx-col w-1/2 flex items-center small-icon">
            <v-select
              :searchable="false"
              :clearable="false"
              name="drpCurrency"
              v-model="tModel.currency"
              v-validate="'required'"
              placeholder="Para birimi seçiniz"
              :options="currencies"
              label="value"
              class="w-full"
              :reduce="(currencies) => currencies.id"
            >
              <span slot="no-options">Eşleşen Veri Yok</span>
            </v-select>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-1/2 flex small-icon">
            <vs-input
              type="number"
              class="w-full"
              placeholder="İlk üyelik süresi"
              v-model="tModel.initialDuration"
            />
          </div>
          <div class="vx-col w-1/2 flex small-icon">
            <vs-checkbox v-model="tModel.isInitialFree"
              >İlk üyelik ücretsiz</vs-checkbox
            >
          </div>
        </div>
      </vs-prompt>
    </div>
  </div>
</template>

<script>
import { repository } from "@/_services/repository.js";
import { VclFacebook } from "vue-content-loading";
import vSelect from "vue-select";
export default {
  components: {
    VclFacebook,
    vSelect,
  },
  data() {
    return {
      loading: true,
      list: [],
      displayAddNewPopup: false,
      tModel: {
        name: "",
        price: "",
        currency: "",
        initialDuration: "",
        isInitialFree: "",
        product: "",
      },
      currencies: [],
    };
  },
  computed: {
    isAllValid() {
      return true;
    },
  },
  methods: {
    getList: async function () {
      let x = await repository.getAll("subscription/getProducts");
      if (x && x.isSuccessful) {
        x = x.list;
        x = repository.convertToJSON(x, "product");
        x = repository.convertToJSON(x, "currency");
        for (let i = 0; i < x.length; i++) {
          if (x[i].product == null) {
            x[i].product = [{ id: -1, value: "Bağlı bir ürün yok!" }];
          }
        }
        this.list = x;
      }
      this.loading = false;
    },
    getCurrencies: async function () {
      let r = await repository.getAll("General/getCurrencies");
      if (r && r.isSuccessful) {
        this.currencies = r.list;
      }
    },
    cancel() {},
    accept() {},
    displayEdit(tr) {

    },
  },

  created() {},
  beforeMount() {
    Promise.all([this.getList(), this.getCurrencies()]);
  },
};
</script>

<style scoped>
.vs-dialog {
  max-width: 50% !important;
}
.vs-dialog-text {
  height: 170px;
}

/* On screens that are 600px or less, set the background color to olive */
@media screen and (max-width: 600px) {
  .vs-dialog {
    max-width: 90% !important;
  }
}
</style>